import { render, staticRenderFns } from "./AddDataSourceApiRestful.vue?vue&type=template&id=b8745a08&scoped=true&"
import script from "./AddDataSourceApiRestful.vue?vue&type=script&lang=js&"
export * from "./AddDataSourceApiRestful.vue?vue&type=script&lang=js&"
import style0 from "./AddDataSourceApiRestful.vue?vue&type=style&index=0&id=b8745a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8745a08",
  null
  
)

export default component.exports